import { render, staticRenderFns } from "./popover.vue?vue&type=template&id=4a6ae898"
import script from "./popover.vue?vue&type=script&lang=js"
export * from "./popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports